/* global axios */
import JwtAuth from './jwtAuth';

const url =
  process.env.FRONTEND_ENV === 'develop'
    ? `${process.env.STAGING_FRONTEND_URL}/contactapps/api`
    : window.location.protocol +
      '//' +
      window.location.hostname +
      '/contactapps/api';

class GuestJourneyAPI {
  // eslint-disable-next-line class-methods-use-this
  async getIntegrationsStatus(accountId) {
    const jwtAuthTokens = await JwtAuth.getUserTokens();
    return axios.get(`${url}/integrations/status`, {
      headers: {
        Authorization: `Bearer ${jwtAuthTokens.access_token}`,
      },
      params: {
        accountId,
      },
    });
  }

  // eslint-disable-next-line class-methods-use-this
  async getReservations(accountId, status = 'CHECKED_IN') {
    const jwtAuthTokens = await JwtAuth.getUserTokens();
    return axios.get(`${url}/persistence/models/reservations/findByStatus`, {
      headers: {
        Authorization: `Bearer ${jwtAuthTokens.access_token}`,
      },
      params: {
        accountId,
        status,
      },
    });
  }
}

export default new GuestJourneyAPI();
